import type { ReactElement } from 'react';

import { APP_SOURCE_URL } from './constants';
import { MicrosoftLogo } from './OfficeLogos';

interface AppSourceButtonProperties {
  compact?: boolean;
}

export function AppSourceButton({ compact = false }: AppSourceButtonProperties): ReactElement {
  return (
    <a
      href={APP_SOURCE_URL}
      target="_blank"
      rel="noreferrer"
      className="border-border bg-card text-foreground hover:bg-muted inline-flex h-10 shrink-0 items-center gap-2.5 rounded-lg border px-3.5 text-sm font-semibold transition-colors"
    >
      <MicrosoftLogo className="size-4 shrink-0" />
      <span>{compact ? 'AppSource' : 'Get it from Microsoft AppSource'}</span>
    </a>
  );
}
